export const applyEstimateTemplatePlaceholders = (
  html: string,
  firstName?: string,
  salesRep?: {
    email?: string | null;
    profile?: {
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber?: string | null;
    } | null;
  } | null,
) => {
  const salesName = [salesRep?.profile?.firstName, salesRep?.profile?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  return html
    .replaceAll("{{CUSTOMER_FIRST_NAME}}", firstName ?? "")
    .replaceAll("{{SALESPERSON_NAME}}", salesName)
    .replaceAll("{{SALESPERSON_EMAIL}}", salesRep?.email ?? "")
    .replaceAll("{{SALESPERSON_PHONE}}", salesRep?.profile?.phoneNumber ?? "");
};
